// extracted by mini-css-extract-plugin
module.exports = {"borderRadius":"4px","unit":"8px","container":"privacy-policy-page__container____cFHuC"};